import type { DataCollector } from "owa-diagnostics-data-collection";
import { lazyRegisterDataCollectorIfNotRegistered } from "owa-diagnostics-data-collection";
import { default as getHostedApp } from "../selectors/getHostedApp";
import { default as getIsInError } from "../selectors/getIsInError";
import { appHostDiagnosticDataDescription as strings_appHostDiagnosticDataDescription } from "../strings/messageExtensionAppInstalled.locstring.json";
import loc from "owa-localize";

export default async function registerDataCollectors(): Promise<void> {
    const appHostDataCollector: DataCollector = {
        dataCollectionAction: appHostDataCollectionAction,
        name: "MetaOSAppHostData",
        odsFileDescription: "App host data",
        description: loc(strings_appHostDiagnosticDataDescription),
    };
    
    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(appHostDataCollector);
}

function appHostDataCollectionAction(): Promise<string> {
    const { primaryAppHostId, viewStates } = getHostedApp();
    const viewState = primaryAppHostId ? viewStates.get(primaryAppHostId) : undefined;
    const appDefinition = viewState?.appDefinition;
    const appId = appDefinition?.id;
    
    let result = {};
    if (!appDefinition) {
        result = {
            appName: "Not Loaded",
        };
    }
    else {
        result = {
            appName: appDefinition?.name /* metaOS app name */,
            appID: appId /* metaOS app id */,
            isInError: viewState ? getIsInError(viewState) : true /* error loading metaOS app */,
        };
    }
    
    return Promise.resolve(JSON.stringify(result));
}
